<template>
  <div class="flex flex-col gap-5 justify-center items-center">
    <div class="text-center text-[#0789B2] flex flex-col gap-4">
      <h1 class="text-[26px] font-bold">{{ getErrorMessage().msg }}</h1>
      <p class="text-xl">{{ getErrorMessage().description }}</p>
    </div>
    <div>
      <div class="grid grid-cols-2 gap-2">
        <div class="flex flex-col items-center gap-3">
          <img class="w-6 h-6" :src="redCross">
          <div class="flex justify-center w-full max-h-[188px] bg-[#32639b] m-auto rounded">
            <img class="h-full object-cover rounded-none" :src="photo" />
          </div>
        </div>
        <div class="flex flex-col items-center gap-3">
          <img class="w-6 h-6" :src="ok">
          <div class="flex h-full items-center bg-[#32639b] m-auto rounded">
            <img class="h-full rounded" :src="isHybrid ? goodExample_hybrid : goodExample" />
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col items-center gap-5">
      <Button buttonName="result.retake" @click="handleRetakePhoto" :disabled="disableButton"/>
      <Button buttonClass="underline text-sm font-bold text-[#00AEEF]" buttonName="instruction.button"
        @click="toggleInstruction()" />
    </div>
  </div>

  <!-- open instructions popup -->
  <Instructions :openInstruction="openInstructions" :isHybrid="isHybrid" @close="toggleInstruction" />
</template>

<script setup>
import fakeIcon from '@/assets/icons/fake.svg'
import ok from '@/assets/icons/ok.svg'
import redCross from '@/assets/icons/redCross.svg'
import goodExample from '@/assets/images/good-qr.jpg'
import goodExample_hybrid from '@/assets/images/hybrid_qr.png'
import { events } from '@/utils/events'
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import Button from '../Button.vue'
import Instructions from '../Instructions.vue'

const { t } = useI18n()

const props = defineProps({
  codeStatus: {
    type: String,
    required: true
  },
  imageQuality: Array,
  photo: String,
  isHybrid: Boolean
})

const disableButton = ref(false)
const openInstructions = ref(false)

const getQualityErrorMessage = computed(() => {
  const too_small = props.imageQuality.includes('too_small')
  const too_big = props.imageQuality.includes('too_big')
  if (too_small) {
    return {
      msg: t('result.qr_too_small.msg'),
      description: t('result.qr_too_small.description')
    }
  } else if (too_big) {
    return {
      msg: t('result.qr_too_large.msg'),
      description: t('result.qr_too_large.description')
    }
  } else {
    return { msg: t('result.generic_erorr') }
  }
})

const getErrorMessage = () => {
  switch (props.codeStatus) {
    case 'auth_unknown':
      return {
        msg: t('result.generic_erorr')
      }
    case 'not_read':
      return {
        msg: t('result.unreadable.msg'),
        description: t('result.unreadable.description')
      }
    case 'bad_quality':
      return getQualityErrorMessage.value
    case 'auth_error':
      return {
        msg: t('result.backend_error'),
        icon: fakeIcon,
      }
    default:
      return {
        msg: t('result.backend_error'),
        icon: fakeIcon,
      }
  }
}

const toggleInstruction = () => {
  openInstructions.value = !openInstructions.value
}

const handleRetakePhoto = () => {
  events.value.triggerTakePicture = true
}

onMounted(() => {
  if (props.codeStatus !== 'bad_quality') {
    disableButton.value = true
  }
})
</script>
